import { useQuery } from '@apollo/react-hooks';
import * as query from './query.gql';
import { StocksTariffQuery as Query } from './__generated__/StocksTariffQuery';

export const useTariff = () => {
  const { data } = useQuery<Query>(query);
  return {
    percent: data?.stocksRemote.tariff.feePercent,
    min: data?.stocksRemote.tariff.minFee,
  };
};
